import { actions } from "./slice";
import { db } from "initializer";
import { createSubscribeCollection } from "../firestoreModuleUtils/operators";
import {
  MessageTabOrder,
  MessageTabOrderRecord,
  UpdateMessageTabOrder,
} from "./";
import { DefaultThunk } from "stores";
import { getUid } from "../app.user/selectors";
import {
  DocumentData,
  FirestoreDataConverter,
  collection,
  doc,
  setDoc,
} from "firebase/firestore";

const messageTabOrdersConverter: FirestoreDataConverter<DocumentData> = {
  toFirestore(member: UpdateMessageTabOrder) {
    return member;
  },
  fromFirestore(snapshot, options): MessageTabOrder {
    const data = snapshot.data(options)!;
    return MessageTabOrderRecord(data);
  },
};

const messageTabOrdersRef = (roomId: string) =>
  collection(db, "rooms", roomId, "messageTabOrders").withConverter(
    messageTabOrdersConverter
  );

export const subscribeRoomMessageTabOrders = createSubscribeCollection(
  actions,
  messageTabOrdersRef
);

export const updateCurrentRoomMessageTabOrder =
  (order: string[]): DefaultThunk =>
  (_, getState) => {
    const state = getState();
    const roomId = state.app.state.roomId;
    const uid = getUid(state);
    if (!roomId || !uid) return;
    return setDoc(doc(messageTabOrdersRef(roomId), uid), {
      messageTabGroups: order,
    });
  };
